import { Checkbox, MenuItem } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IntegrationReactSelect from "../../../forms/autoCompleteInput";
import CustomizedDialogs from "../../customModal";
import DateFnsUtils from "@date-io/date-fns";
import React, { useEffect, useReducer, useState } from "react";
import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import CardComponent from "./lib/CardComponent";
import { RadioButton } from "./lib/Radiobutton";

import { connect, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getNewPurchaseFundList,
  validateSubBroker,
  swpOptions,
  CalcSIPEnddt,
  storeSchemeDetails,
  getNav,
  getOtherSchemes,
  storeSchemeParams,
  submitSipDetails,
  clearingFirstTimeInvestorJourney,
  getCheckPanKotm,
  getCheckPanAotm,
  FreedomSIPSWPschemes,
  isFreedomSIPEligible,
  FreedomSIPTenures,
  getMinimumAmount,
  PurchaseSaveNominee
} from "../../../../store/actions";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  REGULAR,
  FALSE,
} from "../../../../store/types";

import {
  INVESTMENT_FREQUENCY,
  SIP_DAY,
  PAYMENT_MODE,
} from "../../../../store/types";
import CustomLoader from "../../../forms/Loader";
import { format } from "date-fns";
import { KycNotDoneDialog, FreedomSchemeDialog } from "../../customModal";
import { gridColumnsTotalWidthSelector } from "@material-ui/data-grid";
import { formatDate } from "../../../../utils/common";
const SipDetails = (props) => {
  const { state } = useLocation();
  const history = useHistory();
  const initialState = {
    Scheme: { value: "" },
    Category: { value: "" },
    AMC: { value: "" },
    Sub_ARN: { value: "" },
    EUIN: { value: "" },
    "SIP Day": { value: "" },
    Frequency: { value: "" },
    "SIP Period From": { value: "" },
    "SIP Period To": { value: "" },
    "No of Installments": { value: "" },
    MinimumAmount: "",
    Amount: { value: "" },
    MinimumInstallements: "",
    schemeList: [],
    euinList: [],
    sipDateList: [],
    frequencyList: [],
    amcList: [],
    planValue: "",
    optionValue: "",
    schemeValue: "",
    modeList: [],
    umrnList: [],
    UMRN: { value: "" },
    CategoryList: [],
    multiple: "",
    sipAutoRenewal: false,
    perpetualSip: false,
    "Mode of Registration": "",
    "EUIN NO": { value: "yes" },
    "BOB-PIO Payment Option": { value: "no" },
    "Payment (pre-debit) Reference Number": { value: "" },
    "SWP Category": { value: "" },
    "SWP Period To": { value: "" },
    "SWP Period From": { value: "" },
    MinimumWithdrawalAmount: "",
    transactionType: { value: "Normal SIP" },
    "Withdrawal Amount": { value: "" },
    "SIP Tenure": { value: "" },
    swpCategoryList: [],
    swpSchemeList: [],
    tenureList: [],
    swpPlanValue: "",
    swpOptionValue: "",
    swpSchemeValue: "",
    isFreedom: false,
    showFreedom: false,
    AdvanceSwitchDate: { value: "" },
    MinimumLumpsumAmount: "",
    "Lumpsum Amount": { value: "" },
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );
  const BOB = props.token === "ARN-35783" ? false : true;
  const [freedomSchemeDialog, setFreedomSchemeDialog] = useState({ open: false, disabled: false });
  const InputFields = [
    [
      {
        name: "AMC",
        type: "select",
        placeholder: "Select AMC",
        isMandatory: true,
        listName: "amcList",
        disabled: true,
      },
    ],
    [
      {
        name: "Category",
        type: "select",
        placeholder: "Select Category",
        isMandatory: true,
        listName: "CategoryList",
        disabled: false,
      },
    ],
    [
      {
        name: "Scheme",
        type: "Searchselect",
        placeholder: "Select Scheme",
        isMandatory: true,
        listName: "schemeList",
      },
    ],
    [
      {
        name: "Sub_ARN",
        type: "number",
        isMandatory: false,
      },
    ],
    [
      {
        name: "EUIN NO",
        type: "paymentOption",
      },
      {
        name: "EUIN",
        type: "Searchselect",
        placeholder: "Select EUIN",
        isMandatory: formValues["EUIN NO"].value === "no" ? false : true,
        listName: "euinList",
        display: formValues["EUIN NO"].value === "yes" ? false : true,
      },
    ],
    [
      {
        name: "Mode of Registration",
        type: "select",
        placeholder: "Select Mode",
        isMandatory: true,
        listName: "modeList",
        disabled: false,
      },
    ],
    [
      {
        name: "UMRN",
        type: "select",
        placeholder: "Select UMRN",
        listName: "umrnList",
        display:
          formValues["Mode of Registration"].value === "KOTM" ||
          formValues["Mode of Registration"].value === "AOTM"
            ? false
            : true,
        disabled: formValues.umrnList.length === 1 ? true : false,
      },
    ],
    [
      {
        name: "Frequency",
        type: "select",
        placeholder: "Select Frequency",
        isMandatory: true,
        listName: "frequencyList",
        disabled: false,
      },
    ],
    [
      {
        name: "SIP Transaction Type",
        type: "radio",
        display: !formValues.showFreedom,
      },
    ],
    [
      {
        name: "No of Installments",
        type: "number",
        placeholder: !formValues.perpetualSip ? "" : "Perpetual SIP",
        isMandatory: true,
        disabled: !formValues.perpetualSip ? false : true,
        display: formValues.isFreedom,
      },
    ],
    [
      {
        name: "SIP Tenure",
        type: "select",
        placeholder: "Select Tenure",
        isMandatory: true,
        listName: "tenureList",
        display: !formValues.isFreedom,
        disabled: false,
      },
    ],
    [
      {
        name: "SWP Category",
        type: "select",
        placeholder: "Select Category",
        isMandatory: true,
        listName: "swpCategoryList",
        display: !formValues.isFreedom,
        disabled: false,
      },
    ],
    [
      {
        name: "SWP Scheme",
        type: "Searchselect",
        placeholder: "Select Scheme",
        isMandatory: true,
        listName: "swpSchemeList",
        display: !formValues.isFreedom,
        disabled: !freedomSchemeDialog.disabled

      },
    ],
    [
      {
        name: "SIP Day",
        type: "select",
        placeholder: "Select SIP Day",
        isMandatory: true,
        listName: "sipDateList",
        disabled: false,
      },
    ],
    [
      {
        name: "SIP Period From",
        type: "date",
        placeholder: "Start Date",
        isMandatory: true,
        disabled: true,
      },
      {
        name: "SIP Period To",
        type: "date",
        placeholder: "End Date",
        isMandatory: true,
        disabled: true,
      },
    ],
    [
      {
        name: "SWP Period From",
        type: "date",
        placeholder: "Start Date",
        isMandatory: true,
        disabled: true,
        display: !formValues.isFreedom,
      },
      {
        name: "SWP Period To",
        type: "date",
        placeholder: "End Date",
        isMandatory: true,
        display: !formValues.isFreedom,
        disabled: true,
      },
    ],
    [
      {
        name: "SIP Auto Renewal",
        type: "sipAutoRenewal",
      },
    ],
    [
      {
        name: "Perpetual SIP",
        type: "Perpetual",
        display: formValues.isFreedom,
      },
    ],
    [
      {
        name: "Amount",
        type: "number",
        placeholder: "",
        isMandatory: true,
      },
      {
        name: "Lumpsum Amount",
        type: "number",
        placeholder: "",
        isMandatory: props.type === "Lumpsum + SIP" ? true : false,
        display: props.type === "Lumpsum + SIP" ? false : true,
      },
    ],
    [
      {
        name: "Withdrawal Amount",
        type: "number",
        isMandatory: true,
        placeholder: "Enter Withdrawal Amount",
        display: !formValues.isFreedom,
      },
    ],
    [
      {
        name: "BOB-PIO Payment Option",
        type: "paymentOption",
        display: BOB,
      },
    ],
    [
      {
        name: "Payment (pre-debit) Reference Number",
        type: "text",
        placeholder: "Reference Number",
        isMandatory:
          formValues["BOB-PIO Payment Option"].value === "yes" ? false : true,
        display:
          formValues["BOB-PIO Payment Option"].value === "yes" ? false : true,
      },
    ],
  ];
  const [dialog, setDialog] = useState({ open: false, appno: "" });
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [erroropen, setErrorOpen] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const SIP_Date = formValues["SIP Day"].value;
  const Frequency = formValues["Frequency"].value;
  const { AMC } = formValues;
  const fund = AMC.value;

  const setFrequencyList = async () => {
    const selectedScheme = formValues?.schemeValue;
    const selectedPlan = formValues?.planValue;
    const euinParams = {
      opt: INVESTMENT_FREQUENCY,
      fund: fund,
      scheme: selectedScheme || "",
      plan: selectedPlan || "",
    };
    const euinResponse = await props.swpOptions(euinParams);
    const { Dtinformation } = euinResponse;
    const frequencyList = Dtinformation.map((item) => ({
      label: item.FrequencyID,
      value: item.FrequencyID,
      min: item.Minimum_Instalment,
    }));
    setFormValues({ frequencyList });
  };
  const handleScheme = (label) => async (event) => {
    const { schemeList, swpSchemeList } = formValues;
    if (label === "Scheme") {
      const scheme = schemeList.find((item) => item.label === event.label);
      setFormValues({
        Scheme: { value: event },
        planValue: scheme.planValue,
        optionValue: scheme.optionValue,
        schemeValue: scheme.schemeValue,
        // MinimumAmount: scheme.MinimumAmount,
        MinimumLumpsumAmount: scheme.MinimumLumpsumAmount,
        multiple: scheme.multiples || 1,
        isFreedom: false,
        showFreedom: false,
        transactionType: { value: "Normal SIP" },
      });
      setFrequencyList();
    }
    if (label === "SWP Scheme") {
      const scheme = swpSchemeList.find((item) => item.label === event.label);
      const minParams = {
        Fund: fund,
        Scheme: scheme.schemeValue,
        Trtype: "SWP",
        Frequency: formValues.Frequency.value,
      };
      const response = await props.getMinimumAmount(minParams);
      const { DtData } = response;
      setFormValues({
        "SWP Scheme": { value: event },
        swpPlanValue: scheme.planValue,
        swpOptionValue: scheme.optionValue,
        swpSchemeValue: scheme.schemeValue,
        MinimumAmount: scheme.MinimumAmount,
        MinimumWithdrawalAmount: DtData[0].minamt,
      });
    }
    if (label === "EUIN") {
      setFormValues({
        EUIN: { value: event },
      });
    }
  };
  const getFreedomSIPTenures = async () => {
    const params = {
      Fund: fund,
      Scheme: formValues.schemeValue,
      Trtype: "SIP",
      Frequency: formValues.Frequency.value,
    };
    const response = await props.getMinimumAmount(params);
    if (!!response.Table2.length > 0) {
      const filterTenures = response.Table2.filter(
        (ele) => ele.active === "Y"
      ).map((ele) => ({
        label: `${ele.sip_tenure} years`,
        value: ele.sip_tenure,
        multiplier: ele.swp_percent,
      }));
      setFormValues({
        tenureList: filterTenures,
      });
    }
  };
  const handleChange = (label) => async (event) => {
    const maxInstallments = (formValues?.AMC?.value === "176" && formValues["Frequency"]?.value === "Daily") ? 14610 : 999;
    const value = event.target.value;
    if (!value && label !== "Sub_ARN") {
      setFormValues({
        [label]: {
          value,
          isError: true,
          errorMessage: `${label} is Mandatory`,
        },
      });
      return;
    }
    setFormValues({ [label]: { value } });
    switch (label) {
      case "AMC":
        if (value !== "101" && props.type === "SIP") {
          setFormValues({
            [label]: { value },
            Scheme: { value: "" },
            Category: { value: "" },
            Amount: { value: "" },
            "Lumpsum Amount": { value: "" },
            Sub_ARN: { value: "" },
            "SIP Day": { value: "" },
            Frequency: { value: "" },
            "SIP Period From": { value: null },
            "SIP Period To": { value: null },
            "No of Installments": { value: "" },
            isFreedom: false,
            showFreedom: false,
            transactionType: { value: "Normal SIP" },
          });
        } else {
          alert("Only Lumpsum + SIP is allowed");
          setFormValues({
            [label]: { value: "" },
          });
        }
        break;
      case "Category":
        setFormValues({
          [label]: { value },
          Scheme: { value: "" },
          Amount: { value: "" },
          "Lumpsum Amount": { value: "" },
          Sub_ARN: { value: "" },
          "SIP Day": { value: "" },
          Frequency: { value: "" },
          "SIP Period From": { value: null },
          "SIP Period To": { value: null },
          "No of Installments": { value: "" },
          isFreedom: false,
          showFreedom: false,
          transactionType: { value: "Normal SIP" },
        });
        break;
      case "No of Installments":
        if (
          !!value &&
          parseInt(value) < parseInt(formValues.MinimumInstallements)
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " No of Installments should be greater than or equal to Minimum Installments ",
            },
          });
        } if (parseInt(value) > maxInstallments) {
          setFormValues({
            [label]: {
              value: "",
              isError: true,
              errorMessage: `No of Installments should not be greater than ${maxInstallments}`,
            },
          });
        }
        break;
        break;
      case "Mode of Registration":
        if (value === "KOTM") {
          fetchUMRNList("KOTM");
        } else {
          setFormValues({
            UMRN: { value: "" },
          });
        }
        if (value === "AOTM") {
          fetchUMRNList("AOTM");
        } else {
          setFormValues({
            UMRN: { value: "" },
          });
        }
        setFormValues({ [label]: { value } });
        break;
      case "Amount":
        if (!!value && parseInt(value) < parseInt(formValues.MinimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.MinimumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiple) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiple,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        if (formValues.isFreedom) {
          const tenure = formValues["SIP Tenure"].value;
          const findMultiplier = formValues.tenureList.find(
            (ele) => Number(ele.value) === Number(tenure)
          );
          const amount = findMultiplier.multiplier
            ? Number(value) * Number(findMultiplier.multiplier)
            : null;
          setFormValues({
            ["Withdrawal Amount"]: {
              value: amount,
            },
          });
        }
        break;
      case "transactionType":
        if (value === "Freedom") {
          fetchSWPCategoryList();
          getFreedomSIPTenures();
          setFormValues({
            isFreedom: true,
          });
        }
        if (value === "Normal SIP") {
          setFormValues({
            isFreedom: false,
            "No of Installments": { value: "" },
            Amount: { value: "" },
            "Withdrawal Amount": { value: "" },
            "SIP Day": { value: "" },
            "SIP Period From": { value: "" },
            "SWP Period To": { value: "" },
            "SWP Period From": { value: "" },
            "SIP Period To": { value: "" },
            AdvanceSwitchDate: { value: "" },
            MinimumAmount: "",
            MinimumWithdrawalAmount: "",
          });
        }
        setFormValues({
          transactionType: { value },
        });
        break;
      case "SWP Category":
        fetchSWPSchemesList(value);
        setFormValues({
          "SWP Category": { value },
        });
        setFreedomSchemeDialog({ open: true, disabled: false });
        break;
      case "SIP Day":
        getSipDates(value);
        setFormValues({
          [label]: {
            value,
          },
        });
        break;
      case "SIP Tenure":
        setFormValues({
          [label]: { value },
          "No of Installments": { value: Number(value) * 12 },
          "Amount": { value: "" },
          "SIP Day": { value: "" },
          "SIP Period From": { value: "" },
          "SIP Period To": { value: "" },
          "SWP Period From": { value: "" },
          "SWP Period To": { value: "" },
          "SWP Scheme": { value: "" },
          "SWP Category": { value: "" },
          "Withdrawal Amount": { value: "" },
          "Lumpsum Amount": { value: "" },
          swpPlanValue: "",
          swpOptionValue: "",
          swpSchemeValue: "",
          MinimumAmount: "",
          MinimumWithdrawalAmount: "",
          swpSchemeList: []
        });

        break;
      case "Lumpsum Amount":
        if (
          !!value &&
          parseInt(formValues.MinimumLumpsumAmount) > parseInt(value)
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.MinimumLumpsumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiple) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiple,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        break;
      default:
        setFormValues({ [label]: { value } });
        break;
    }
  };
  const getSipDates = async (value) => {
    const sipDateParams = {
      fund: fund,
      trtype: "SIP",
      StartDate: value,
      Installments: formValues["No of Installments"].value,
      Frequency: formValues.Frequency.value,
      modeofregistration: formValues["Mode of Registration"].value,
    };
    try {
      setIsLoading(true);
      const sipDateResponse = await props.CalcSIPEnddt(sipDateParams);
      const {
        DtData: [dates],
      } = sipDateResponse;
      const {
        SIP_EndDate,
        SIP_StartDate,
        SWP_StartDate,
        SWP_EndDate,
        AdvanceSwitchDate,
      } = dates;
      const End_dt = !!SIP_EndDate ? SIP_EndDate.split("/") : [];
      const Start_dt = !!SIP_StartDate ? SIP_StartDate.split("/") : [];
      const SWP_End_dt = !!SWP_EndDate ? SWP_EndDate.split("/") : [];
      const SWP_Start_dt = !!SWP_StartDate ? SWP_StartDate.split("/") : [];
      setFormValues({
        "SIP Period From": {
          value: !!End_dt
            ? new Date().setFullYear(Start_dt[2], Start_dt[1] - 1, Start_dt[0])
            : "",
        },
        "SIP Period To": {
          value: !!Start_dt
            ? new Date().setFullYear(End_dt[2], End_dt[1] - 1, End_dt[0])
            : "",
        },
        "SWP Period From": {
          value: !!SWP_Start_dt
            ? new Date().setFullYear(
                SWP_Start_dt[2],
                SWP_Start_dt[1] - 1,
                SWP_Start_dt[0]
              )
            : "",
        },
        "SWP Period To": {
          value: !!SWP_End_dt
            ? new Date().setFullYear(
                SWP_End_dt[2],
                SWP_End_dt[1] - 1,
                SWP_End_dt[0]
              )
            : "",
        },
        AdvanceSwitchDate: { value: AdvanceSwitchDate },
      });
    } catch (e) {
      console.log("error", e);
      setFormValues({
        "No of Installments": {
          value: "",
          isError: true,
          errorMessage: `Enter Valid Number of Installments`,
        },
        "SIP Period From": { value: null },
        "SIP Period To": { value: null },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const validate = (label) => async (event) => {
    const value = event.target.value;
    switch (label) {
      case "Amount":
        if (!!value && parseInt(value) < parseInt(formValues.MinimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to Minimum Amount ",
            },
          });
        }
        break;
      case "No of Installments":
        if (!value && formValues.perpetualSip) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage: `${label} is Mandatory`,
            },
          });
          return;
        }
        break;
      default:
        break;
    }
  };

  const getMinInstallment = async (event) => {
    const value = event.target.value;
    const { frequencyList, schemeValue, optionValue, AMC } = formValues;


    const installment = frequencyList.find((item) => item.value === value);
    const frequencyParams = {
      opt: SIP_DAY,
      fund: fund,
      astscheme: value,
    };
    const freedomParams = {
      fund: fund,
      scheme: schemeValue,
      opt: optionValue,
      frequency: value,
    };
    const isFreedomSIPEligible = await props.isFreedomSIPEligible(
      freedomParams
    );
    const frequencyResponse = await props.swpOptions(frequencyParams);
    const frequencyData = frequencyResponse.Dtinformation;
    const sipDateList = frequencyData.map((item) => ({
      label: item.sip_cycleid,
      value: item.sip_cycleid,
    }));
    const minParams = {
      Fund: AMC.value,
      Scheme: formValues.schemeValue,
      Trtype: "SIP",
      Frequency: value,
    };
    const response = await props.getMinimumAmount(minParams);
    if (response) {
      const { DtData } = response;
      let minAmount = DtData[0].minamt;
      setFormValues({
        sipDateList,
        MinimumInstallements: installment.min,
        Frequency: { value },
        perpetualSip: false,
        "SIP Period From": { value: null },
        "SIP Period To": { value: null },
        "No of Installments": { value: "" },
        "SIP Day": { value: "" },
        showFreedom:
          isFreedomSIPEligible?.DtData[0]?.freedom_ligibile_flag === "Y"
            ? true
            : false,
        isFreedom: false,
        Frequency: { value },
        transactionType: { value: "Normal SIP" },
        MinimumAmount: minAmount
      });
    } else {
      setFormValues({
        sipDateList: [],
        MinimumInstallements: "",
        Frequency: { value: "" },
        perpetualSip: false,
        "SIP Period From": { value: null },
        "SIP Period To": { value: null },
        "No of Installments": { value: "" },
        "SIP Day": { value: "" },
        isFreedom: false,
        Frequency: { value: "" },
        MinimumAmount: ""
      });
    }

  };
  const fetchAmcList = async () => {
    try {
      setIsLoading(true);
      const params = {
        opt: "A",
      };
      const response = await props.getNewPurchaseFundList(params);
      const { Dtinformation } = response;
      const amcList = Dtinformation.map((item) => ({
        value: item.amc_code,
        label: item.amc_name,
      }));
      setFormValues({ amcList, AMC: { value: props.applicantparams.fund } });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSWPCategoryList = async () => {
    try {
      setIsLoading(true);
      const schemeParams = {
        fund: fund,
        plnmode: "Regular",
      };
      const schemeResponse = await props.FreedomSIPSWPschemes(schemeParams);
      const { DtData } = schemeResponse;
      const freedomSWPCategoryList = DtData.map((item) => {
        return {
          label: item.category,
          value: item.category,
        };
      });
      setFormValues({
        swpCategoryList: freedomSWPCategoryList,
      });
    } catch (e) {
      console.log(e);
      setFormValues({ schemeList: [] });
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSWPSchemesList = async (value) => {
    try {
      setIsLoading(true);
      const schemeParams = {
        fund: fund,
        plnmode: "Regular",
        category: value,
      };
      const schemeResponse = await props.FreedomSIPSWPschemes(schemeParams);
      const { DtData } = schemeResponse;
      const freedomSWPSchmesList = DtData.map((item) => {
        return {
          label: item.sch_desc,
          value: item.fm_Scheme,
          planValue: item.fm_plan,
          optionValue: item.fm_option,
          schemeValue: item.fm_Scheme,
          MinimumAmount: item.freedom_sip_min_amt,
        };
      });
      setFormValues({
        swpSchemeList: freedomSWPSchmesList,
      });
    } catch (e) {
      console.log(e);
      setFormValues({ schemeList: [] });
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSchemeList = async () => {
    try {
      setIsLoading(true);
      const schemeParams = {
        schtype: "Regular",
        category: formValues.Category.value,
        acno: "0",
        fundCode: formValues.AMC.value,
        trantype: "I",
      };
      const schemeResponse = await props.getOtherSchemes(schemeParams);
      const { DtData } = schemeResponse;
      const schemeList = DtData.map((item) => {
        return {
          label: item.fm_schdesc,
          value: item.fm_scheme,
          planValue: item.fm_plan,
          optionValue: item.fm_option,
          schemeValue: item.fm_scheme,
          // MinimumAmount: item.SIPminamt,
          multiples: item.multiples,
          MinimumLumpsumAmount: item.fm_newpur,
        };
      });
      setFormValues({
        schemeList,
      });
    } catch (e) {
      console.log(e);
      setFormValues({ schemeList: [] });
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPaymodeList = async () => {
    try {
      setIsLoading(true);
      const params = {
        opt: PAYMENT_MODE,
        fund: fund,
        astscheme: props.applicantparams.i_pangno,
        acno: "0",
      };
      const response = await props.swpOptions(params);
      if (response) {
        setFormValues({
          modeList: response.Dtinformation.filter(
            (ele) => fund !== "129" || ele.Pay_Mode !== "AOTM"
          ).map((item) => ({ label: item.Pay_Mode, value: item.Pay_Mode_Val })),
        });
      }
    } catch (e) {
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEuinList = async () => {
    try {
      setIsLoading(true);
      if (!!fund) {
        const response = await props.validateSubBroker({
          Fund: fund,
          SubAgentCd: `ARN-${formValues?.Sub_ARN?.value.trim() || ""}`,
          AgentCd: props.token,
        });
        const { DtData } = response;
        const euinList = DtData.map((item) => ({
          value: item.abm_name,
          label: item.abm_agent,
        }));
        if (euinList.length === 1) {
          setFormValues({
            EUIN: {
              value: { label: euinList[0].label, value: euinList[0].value },
            },
          });
        }
        setFormValues({ euinList: euinList });
      }
    } catch (e) {
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCategoryList = async () => {
    try {
      setIsLoading(true);
      let params = { plntype: REGULAR };
      params = { ...params, opt: "AT", fund: fund };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      const response = await props.getNewPurchaseFundList(params, types);
      const { Dtinformation } = response;
      const categoryList = Dtinformation.map((item) => ({
        value: item.fm_subcategory,
        label: item.fm_subcategory,
      }));
      setFormValues({ CategoryList: categoryList });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAmcList();
  }, []);
  useEffect(() => {
    (async function () {
      if (!!fund) {
        await fetchSchemeList();
        await fetchEuinList();
        await fetchPaymodeList();
      }
    })();
  }, [formValues.Category.value]);
  useEffect(() => {
    fetchCategoryList();
  }, [fund]);
  const fetchUMRNList = async (type) => {
    setIsLoading(true);

    const { AMC } = formValues;
    try {
      const params = {
        Fund: AMC.value,
        PAN: props.applicantparams.i_pangno,
        Acno: 0,
      };
      const response =
        type === "KOTM"
          ? await props.getCheckPanKotm(params)
          : await props.getCheckPanAotm(params);
      const { Table1 } = response;
      const umrnList = Table1.map((item) => ({
        value: item,
        label: item.UMRNNO,
      }));
      if (umrnList.length > 1) {
        const maxAmt = Table1.reduce(
          (max, obj) => (obj.Amt > max ? obj.Amt : max),
          0
        );
        const filteredData = Table1.filter((obj) => obj.Amt === maxAmt);
        setFormValues({ UMRN: { value: filteredData[0] } });
      }
      if (umrnList.length === 1) {
        setFormValues({ UMRN: { value: umrnList[0].value } });
      }
      setFormValues({ umrnList: umrnList });
    } catch (err) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  const handlechangeSIPEndDateChange = () => {
    const { perpetualSip } = formValues;
    let Umrn_endDate;
    const URMN_enddate =
      formValues["UMRN"]?.value["MANDATE END DATE"]?.split("/");
    const End_dt = "31/12/2099".split("/");
    const endDate = new Date().setFullYear(End_dt[2], End_dt[1] - 1, End_dt[0]);
    if (formValues["UMRN"]?.value["MANDATE END DATE"]) {
      Umrn_endDate = new Date().setFullYear(
        URMN_enddate[2],
        URMN_enddate[1] - 1,
        URMN_enddate[0]
      );
    }
    let selectedFrequency = formValues["Frequency"].value;
    let startDate = new Date();
    let EndDate =
      formValues["Mode of Registration"].value === "KOTM"
        ? new Date(Umrn_endDate)
        : new Date(endDate);
    let monthsDifference =
      (EndDate.getFullYear() - startDate.getFullYear()) * 12 +
      (EndDate.getMonth() - startDate.getMonth());
    let noofFrequency =
      selectedFrequency == "Monthly"
        ? monthsDifference
        : selectedFrequency == "Daily"
        ? Math.floor((EndDate - startDate) / (1000 * 60 * 60 * 24))
        : selectedFrequency == "Weekly"
        ? (EndDate - startDate) / (1000 * 60 * 60 * 24) / 7
        : selectedFrequency == "Quarterly"
        ? Math.floor(monthsDifference / 3)
        : selectedFrequency == "Yearly"
        ? Math.floor(monthsDifference / 12)
        : "";
    if (!perpetualSip && formValues["UMRN"]?.value) {
      setFormValues({
        sipAutoRenewal:false,
        perpetualSip: !perpetualSip,
        "SIP Period To": {
          value:
            formValues["Mode of Registration"].value === "KOTM"
              ? Umrn_endDate
              : endDate,
        },
        "No of Installments": {
          value: Math.floor(noofFrequency),
        },
      });
    } else if (!perpetualSip) {
      setFormValues({
        sipAutoRenewal:false,
        perpetualSip: !perpetualSip,
        "SIP Period To": {
          value: endDate,
        },
        "No of Installments": {
          value: Math.floor(noofFrequency),
        },
      });
    } else if (!!perpetualSip) {
      setFormValues({
        perpetualSip: !perpetualSip,
      });
    }
  };
  const closeModel = () => {
    history.replace("/new-transaction");
  };
  const gotoTransactionTypes = () => {
    if (props.tran_enable_flag === "Y") {
      history.replace("/new-transaction");
    } else {
      history.replace("/");
    }
  };

  const exitModel = () => {
    setErrorOpen(false);
  };
  const proceed = () => {
    history.push({
      pathname: "/new-transaction/eNACH/digital/transact",
      state: { pan: props.applicantparams.i_pangno },
    });
  };
  const continueFreedomModel = async () => {
    setFreedomSchemeDialog({ open: false, disabled: false });

    const findScheme = formValues.swpSchemeList.find((ele) => ele.optionValue === formValues.optionValue && ele.schemeValue === formValues.schemeValue && ele.planValue === formValues.planValue)
    const minParams = {
      Fund: fund,
      Scheme: findScheme.schemeValue,
      Trtype: "SWP",
      Frequency: formValues.Frequency.value,
    };
    const response = await props.getMinimumAmount(minParams);
    const { DtData } = response;
    setFormValues({
      "SWP Scheme": { value: findScheme },
      swpPlanValue: findScheme.planValue,
      swpOptionValue: findScheme.optionValue,
      swpSchemeValue: findScheme.schemeValue,
      MinimumAmount: findScheme.MinimumAmount,
      MinimumWithdrawalAmount: DtData[0].minamt,
    });
  }
  const exitFreedomModel = () => {
    setFreedomSchemeDialog({ open: false, disabled: true });
  };

  const handleSubARNBlur = () => {
    fetchEuinList();
  };
  const dispatch = useDispatch();
  const submit = async () => {
    const {
      schemeList,
      euinList,
      amcList,
      modeList,
      CategoryList,
      umrnList,
      AMC,
      Category,
      sipDateList,
      swpSchemeList,
      tenureList,
      frequencyList,
      swpCategoryList,
      MinimumInstallements,
      MinimumAmount,
      planValue,
      optionValue,
      schemeValue,
      type,
      ct,
      multiple,
      perpetualSip,
      EUIN,
      Sub_ARN,
      swpPlanValue,
      swpOptionValue,
      swpSchemeValue,
      isFreedom,
      showFreedom,
      MinimumWithdrawalAmount,
      transactionType,
      MinimumLumpsumAmount,
      AdvanceSwitchDate,
      sipAutoRenewal,
      ...others
    } = formValues;
    let d1, d2;
    const split_enddate =
      formValues["SIP Period To"]?.value &&
      format(formValues["SIP Period To"].value, "MM/dd/yyyy").split("/");
    const split_mandatedate =
      formValues["UMRN"]?.value?.["MANDATE END DATE"] &&
      formValues["UMRN"].value["MANDATE END DATE"].split("/");

    if (split_enddate?.length === 3) {
      d1 = new Date(
        Number(split_enddate[2]),
        Number(split_enddate[0]) - 1,
        Number(split_enddate[1])
      );
    }
    if (split_mandatedate?.length === 3) {
      d2 = new Date(
        Number(split_mandatedate[2]),
        Number(split_mandatedate[1]) - 1,
        Number(split_mandatedate[0])
      );
    }
    if (split_mandatedate && split_mandatedate.length === 3) {
      d2 = new Date(
        Number(split_mandatedate[2]),
        Number(split_mandatedate[1]) - 1,
        Number(split_mandatedate[0])
      );
    }
    const {
      "EUIN NO": euin,
      "BOB-PIO Payment Option": bobPayment,
      "Mode of Registration": mode,
    } = formValues;
    const filters = {
      noof: ["No of Installments"],
      bob: ["Payment (pre-debit) Reference Number"],
      boboption: ["BOB-PIO Payment Option"],
      euindeclaration: ["EUIN NO"],
      umrn: ["UMRN"],
    };

    let filteredKeys = Object.keys(others).filter(
      (ele) =>
        !(perpetualSip && filters.noof.includes(ele)) &&
        !(euin.value === "no" && filters.euindeclaration.includes(ele)) &&
        !(
          bobPayment !== "yes" &&
          (filters.boboption.includes(ele) || filters.bob.includes(ele))
        )
    );

    let validatedKeys =
      mode.value === "KOTM"
        ? filteredKeys
        : filteredKeys.filter((ele) => !filters.umrn.includes(ele));

    let initialFinalKeys = !formValues.isFreedom
      ? validatedKeys.filter(
          (ele) =>
            ![
              "SWP Category",
              "SWP Scheme",
              "Withdrawal Amount",
              "SIP Tenure",
              "SWP Period To",
              "SWP Period From",
              "AdvanceSwitchDate",
            ].includes(ele)
        )
      : validatedKeys;
    const finalKeys =
      props.type === "SIP"
        ? initialFinalKeys.filter((ele) => !["Lumpsum Amount"].includes(ele))
        : initialFinalKeys;
    const findError = finalKeys.every((key) => !!others[key].value);
    if (!findError) {
      finalKeys.forEach((key) => {
        key !== "Sub_ARN" &&
          !others[key].value &&
          setFormValues({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "sipType"
                  ? "SIP Type"
                  : key === "Category"
                  ? "Category"
                  : key === "Scheme"
                  ? "Scheme"
                  : key === "investmentFrequency"
                  ? "Investment frequency"
                  : key === "installments"
                  ? "Installments"
                  : key === "sipDay"
                  ? "SIP day"
                  : key === "sip_start_date"
                  ? "SIP Start date"
                  : key === "sip_end_date"
                  ? "SIP end date"
                  : key === "installmentAmount"
                  ? "Installment Amount"
                  : key
              } is Mandatory`,
            },
          });
      });

      return;
    } else if (
      others["No of Installments"].value < MinimumInstallements &&
      !formValues.perpetualSip
    ) {
      setFormValues({
        "No of Installments": {
          ...others["No of Installments"],
          isError: true,
          errorMessage: `No of Installments should be greater than or equal to Minimum Installments`,
        },
      });

      return;
    } else if (parseInt(others["Amount"].value) < parseInt(MinimumAmount)) {
      setFormValues({
        Amount: {
          ...others["Amount"],
          isError: true,
          errorMessage: `Amount should be greater than or equal to Minimum Amount`,
        },
      });

      return;
    } else if (formValues.Amount.value % formValues.multiple !== 0) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage: "Amount should be a multiple of " + formValues.multiple,
        },
      });
      return;
    } else if (
      formValues["Mode of Registration"].value === "KOTM" &&
      formValues["UMRN"].value.Amt < formValues.Amount.value
    ) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage: `SIP installment amount cannot exceed
      mandate registration limit of ${formValues["UMRN"]?.value?.Amt}.`,
        },
      });
    } else if (
      !BOB &&
      formValues["BOB-PIO Payment Option"] === "yes" &&
      !/^[sS]\d{8}$/.test(
        formValues["Payment (pre-debit) Reference Number"].value
      )
    ) {
      setFormValues({
        "Payment (pre-debit) Reference Number": {
          value: formValues["Payment (pre-debit) Reference Number"].value,
          isError: true,
          errorMessage: "Enter a valid reference number*",
        },
      });

      return;
    } else if (!isChecked) {
      alert("Please accept the terms and conditions to proceed");

      return;
    } else if (!EUIN.value && formValues["EUIN NO"].value === "yes") {
      setFormValues({
        EUIN: {
          value: "",
          isError: true,
          errorMessage: `Please select EUIN`,
        },
      });
    } else if (d1 > d2) {
      setFormValues({
        "SIP Period To": {
          value: "",
          isError: true,
          errorMessage: `SIP end date cannot exceed mandate validity
          date of ${formValues["UMRN"].value["MANDATE END DATE"]}.`,
        },
      });
      return;
    } else if (
      Number(formValues["Withdrawal Amount"].value) <
        Number(formValues.MinimumWithdrawalAmount) &&
      !!formValues.isFreedom
    ) {
      setFormValues({
        ["Withdrawal Amount"]: {
          value: "",
          isError: true,
          errorMessage: `Withdrawal amount should be greater than ${formValues.MinimumWithdrawalAmount}  `,
        },
      });
      return;
    } else if (
      Number(formValues["Withdrawal Amount"].value) <
        formValues.MinimumWithdrawalAmount &&
      !!formValues.isFreedom
    ) {
      setFormValues((prevValues) => ({
        ...prevValues,
        ["Withdrawal Amount"]: {
          value: "",
          isError: true,
          errorMessage: `Withdrawal amount should be greater than ${formValues.MinimumWithdrawalAmount}`,
        },
      }));
      return;
    } else if (
      parseInt(others["Lumpsum Amount"].value) <
        parseInt(formValues.MinimumLumpsumAmount) &&
      props.type === "Lumpsum + SIP"
    ) {
      setFormValues({
        "Lumpsum Amount": {
          ...others["Lumpsum Amount"],
          isError: true,
          errorMessage: `Amount should be greater than or equal to Minimum Amount`,
        },
      });

      return;
    } else if (others["Lumpsum Amount"].value % formValues.multiple !== 0) {
      setFormValues({
        "Lumpsum Amount": {
          value: formValues["Lumpsum Amount"].value,
          isError: true,
          errorMessage: "Amount should be a multiple of " + formValues.multiple,
        },
      });
      return;
    }  else {
      if (
        (formValues["Mode of Registration"]?.value === "KOTM" ||
          formValues["Mode of Registration"]?.value === "AOTM") &&
        formValues.sipAutoRenewal
      ) {
       const response = validateSipAutoRenewalMandate(formValues)
       if (!response) return; 

      }
      setIsLoading(true);
      try {
        const response = await props.PurchaseSaveNominee({ ...props.nomineDetails.payload ? props.nomineDetails.payload : {} });
        if (!!response?.Dtinformation[0]?.nom_id || response?.Dtinformation[0]?.nom_id === null) {
          const { amcList } = formValues;
          const amc = amcList.find((item) => item.value === fund);
          const schemedetails = {
            IWishToNominate: props?.nomineDetails?.IWishToNominate,
            i_fund: fund,
            i_scheme: schemeValue,
            i_plan: planValue,
            i_option: optionValue,
            i_subarncode: !!formValues.Sub_ARN.value ? `ARN-${formValues.Sub_ARN.value}` : "",
            sip_amt: others.Amount.value,
            i_disitributorid: props.token,
            i_EUINno:
              formValues["EUIN NO"].value === "no"
                ? ""
                : formValues.EUIN?.value?.value,
            i_frequency: others.Frequency.value,
            i_noofinst: others["No of Installments"].value,
            i_sipstartdt: format(others["SIP Period From"].value, "MM/dd/yyyy"),
            i_sipenddt: format(others["SIP Period To"].value, "MM/dd/yyyy"),
            i_paymode: formValues["Mode of Registration"].value,
            i_umrno: formValues["UMRN"]?.value?.UMRNNO,
            subtrtype: { Freedom: "FreedomSIP" }[formValues.transactionType?.value] || "",
            Flex_max: !!formValues.isFreedom ? formValues["Withdrawal Amount"].value : 0,
            Freedom_category: !!formValues.isFreedom ? formValues["SWP Category"].value : "",
            Freedom_scheme: !!formValues.isFreedom ? formValues.swpSchemeValue : "",
            Freedom_Plan: !!formValues.isFreedom ? formValues.swpPlanValue : "",
            Freedom_option: !!formValues.isFreedom ? formValues.swpOptionValue : "",
            SWPStartdate: !!formValues.isFreedom ? format(formValues["SWP Period From"].value, "dd/MM/yyyy") : "",
            SWPEnddate: !!formValues.isFreedom ? format(formValues["SWP Period To"].value, "dd/MM/yyyy") : "",
            AdvanceSwitchDate: !!formValues.isFreedom ? formValues.AdvanceSwitchDate.value : "",
            i_amount: props.type === "Lumpsum + SIP" ? formValues["Lumpsum Amount"].value : 0,
          };
          const paramsSip = {
            ...props.applicantparams,
            ...props.investmentparams,
            ...props.fatcaDetails,
            ...schemedetails,
            ...props?.nomineDetails?.dotnetApiSubmitKeys,
            Nomslno: response.Dtinformation[0]?.nom_id,
            i_trtype: props.type === "Lumpsum + SIP" ? "SIN" : "SINI",
            i_appldt: format(new Date(), "MM/dd/yyyy"),
            i_chqdt: format(new Date(), "MM/dd/yyyy"),
            i_entby: props.userId,
            i_sipflag: "Y",
            Invdistflag: "W",
            Autorenwal_Flag: !!sipAutoRenewal ? "Y" : "N",
            // bob_pio_flag:formValues["BOB-PIO Payment Option"],
            // bob_pio_refno:formValues["Payment (pre-debit) Reference Number"].value,
          };
          try {
            const responseSip = await props.submitSipDetails(paramsSip);
            if (responseSip.error) {
              alert(responseSip.error);
              return;
            }
            if (!!responseSip) {
              const { DtData } = responseSip;
              const { appno } = DtData[0];
              setIsLoading(false);
              dispatch(clearingFirstTimeInvestorJourney());
              setDialog({ appno: appno, open: true });
            }
          } catch (err) {
            if (
              err === "Please register eNACH to use mode of registration as KOTM"
            ) {
              setIsLoading(false);
              setErrorOpen(true);
              setMessageAlert(err);
            } else {
              alert(err);
            }
          } finally {
            setIsLoading(false);
          }
        }
      } catch (e) {
        alert(e)
      }
    }
  };
  const handleSipAutoRenewalChange = () => {
    const { sipAutoRenewal } = formValues;
    setFormValues({
      sipAutoRenewal: !sipAutoRenewal,
    });
  };
  
  const isPGIM = fund==="129";
  const isEnableSipAutoRenewal =
    isPGIM &&
    (formValues.Frequency.value === "Monthly" ||
      formValues.Frequency.value === "Quarterly") &&
    !formValues.perpetualSip;
  return (
    <>
      <CustomLoader display={isLoading} />
      <CardComponent title="Scheme Details">
        <></>
        {InputFields.map((section, index) => (
          <div className="flex" key={index}>
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin transaction-details"
                style={{
                  display: field.display ? "none" : "",
                }}
                key={field.name}
              >
                {field.type === "select" ? (
                  <CustomizedSelect
                    name={field.name === "SIP Tenure" ? "SIP Tenure (Years)" : field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={
                      field.name === "Frequency"
                        ? getMinInstallment
                        : handleChange(field.name)
                    }
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={!!field.disabled ? field.disabled : false}
                  >
                    {Array.isArray(formValues[field.listName]) &&
                      formValues[field.listName].map((i, index) => (
                        <MenuItem
                          value={field.name === "Scheme" ? i : i.value}
                          key={index}
                        >
                          {i.label}
                        </MenuItem>
                      ))}
                  </CustomizedSelect>
                ) : field.type === "Searchselect" ? (
                  <>
                    <div className="goal-amount">
                      <div className="input-name input-integrated-label">
                        {field.name}
                      </div>
                      <IntegrationReactSelect
                        suggestions={
                          Array.isArray(formValues[field.listName])
                            ? formValues[field.listName].map((i) => ({
                                label: i.label,
                                value: i.value,
                              }))
                            : []
                        }
                        value={
                          formValues[field.name]
                            ? formValues[field.name].value
                            : ""
                        }
                        placeholder={`Select ${field.name}`}
                        handleChange={handleScheme(field.name)}
                        disabled={field.disabled}
                        isError={
                          formValues[field.name]
                            ? formValues[field.name].isError
                            : false
                        }
                        errorMessage={
                          formValues[field.name]
                            ? formValues[field.name].errorMessage
                            : ""
                        }
                      />
                    </div>
                    {field.name === "Amount" && (
                      <span>Minimum Amount : ₹ {formValues.minimumAmount}</span>
                    )}
                  </>
                ) : field.type === "date" ? (
                  <>
                    <div
                      className="input-name"
                      style={{ margingBottom: "10px" }}
                    >
                      {field.name}
                    </div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        InputProps={{ readOnly: true }}
                        required={true}
                        className="selects"
                        value={formValues[field.name].value || null}
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="mui-pickers-date"
                        disabled={field.disabled}
                        helperText={formValues[field.name].errorMessage}
                        error={formValues[field.name].isError}
                      />
                    </MuiPickersUtilsProvider>
                  </>
                ) : field.type === "sipAutoRenewal" ? (
                  <div>
                    {!!formValues["SIP Day"].value && isEnableSipAutoRenewal && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          checked={!!formValues.sipAutoRenewal}
                          onClick={handleSipAutoRenewalChange}
                        />
                        <div
                          style={{
                            fontFamily: "OpenSans-SemiBold",
                            fontSize: 14,
                          }}
                        >
                          SIP Auto Renewal
                        </div>
                      </div>
                    )}
                  </div>
                ) : field.type === "Perpetual" ? (
                  <div>
                    {!!formValues["SIP Day"].value &&
                      props?.applicantparams?.typeofinvestor !== "M" && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            onClick={handlechangeSIPEndDateChange}
                            // value={!!formValues.perpetualSip}
                            checked={!!formValues.perpetualSip}
                          />
                          <div
                            style={{
                              fontFamily: "OpenSans-SemiBold",
                              fontSize: 14,
                            }}
                          >
                            Perpetual SIP
                          </div>
                        </div>
                      )}
                  </div>
                ) : field.type === "paymentOption" ? (
                  <>
                    <RadioButton
                      value={formValues[field.name].value}
                      Heading={field.name === "EUIN NO" ? "EUIN" : field.name}
                      onChange={handleChange(field.name)}
                    />
                    <>
                      {formValues["EUIN NO"].value === "no" && (
                        <span className="euin-text">
                          {" "}
                          I/We hereby confirm that the EUIN box has been
                          intentionally left the blank by me/us as this is an
                          'execution-only' transaction without any interaction
                          or advice by any personnel of the above distributor or
                          notwithstanding the advice of in-appropriateness,if
                          any provided by any personnel of the distributor and
                          the distributor has not charged any advisory fees on
                          this transaction
                        </span>
                      )}
                    </>
                  </>
                ) : field.type === "radio" ? (
                  <>
                    <div>SIP Transaction Type</div>
                    <RadioGroup
                      aria-label="Search"
                      name="search"
                      value={formValues.transactionType.value}
                      style={{ flexDirection: "row" }}
                      onChange={handleChange("transactionType")}
                    >
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="Normal SIP"
                          control={
                            <Radio
                              className="investor-search-radio"
                              style={{ color: "#1BBCEE" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">Normal SIP</div>
                      </div>
                      {formValues.showFreedom && (
                        <div className="investor-radio-button">
                          <FormControlLabel
                            value="Freedom"
                            control={
                              <Radio
                                className="investor-search-radio"
                                style={{ color: "#1BBCEE" }}
                              />
                            }
                            className="investor-formcontrol-label"
                            style={{ margin: 0 }}
                          />
                          <div className="investor-form-label">
                            Prosperity SIP
                          </div>
                        </div>
                      )}
                    </RadioGroup>
                  </>
                ) : (
                  <div className="goal-amount">
                    <Input
                      name={
                        field.name === "Amount"
                          ? "SIP Amount"
                          : field.name === "Sub_ARN"
                          ? "Sub ARN Code"
                          : field.name
                      }
                      // image="/images/nav.png"
                      isMandatory={field.isMandatory}
                      value={
                        formValues[field.name]
                          ? formValues[field.name].value
                          : ""
                      }
                      onChange={handleChange(field.name)}
                      placeholder={field.placeholder}
                      onBlur={
                        field.name === "Amount"
                          ? validate("Amount")
                          : field.name === "No of Installments"
                          ? validate("No of Installments")
                          : field.name === "Sub_ARN"
                          ? handleSubARNBlur
                          : handleChange(field.name)
                      }
                      type={field.type}
                      isError={formValues[field.name].isError}
                      isShowError={formValues[field.name].isError}
                      errorMessage={formValues[field.name].errorMessage}
                      id={`${field.name}Field`}
                      disabled={field.disabled}
                      onKeyDown={(e) => e.key === "." && e.preventDefault()}
                    />
                    <span
                      style={{
                        fontFamily: "OpenSans-SemiBold",
                        marginTop: "10px",
                      }}
                    >
                      {field.name === "No of Installments"
                        ? `Mimimum No of Installments : ${formValues.MinimumInstallements}`
                        : field.name === "Amount"
                        ? `Minimum Amount : ${formValues.MinimumAmount}`
                        : field.name === "Lumpsum Amount" &&
                          props.type === "Lumpsum + SIP"
                        ? `Minimum Lumpsum Amount : ${formValues.MinimumLumpsumAmount}`
                        : null}
                    </span>
                  </div>
                )}
                {formValues["UMRN"]?.value && field.name === "UMRN" && (
                  <div className="redemption-details">
                    <div className="keys">
                      <div>Mandate amount limit</div>
                      <div>Start Date</div>
                      <div>End Date</div>
                      <div>Bank Name</div>
                      <div>Bank Account No</div>
                    </div>
                    <div className="values">
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value.Amt
                          : ""}
                        (INR)
                      </div>
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["MANDATE START DATE"]
                          : ""}{" "}
                      </div>
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["MANDATE END DATE"]
                          : ""}
                      </div>
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["BANK NAME"]
                          : ""}
                      </div>{" "}
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["BANK A/C NO"]
                          : ""}
                      </div>
                    </div>
                  </div>
                )}
                {formValues["UMRN"]?.value &&
                  field.name === "UMRN" &&
                  formValues?.umrnList.length === 1 && (
                    <span className="euin-text">
                      The investor has only one active{" "}
                      {formValues["Mode of Registration"]?.value} mandate.
                    </span>
                  )}
              </div>
            ))}
          </div>
        ))}
        {formValues.isFreedom && (
          <div>
            <span
              style={{
                color: "red",
                fontWeight: 500,
                fontFamily: "Ubuntu-Regular",
              }}
            >
              NOTE:
            </span>{" "}
            On completion of the chosen SIP period, the units accumulated
            through Prosperity SIP shall be transferred to the selected target
            scheme (the scheme from which the SWP will get processed). If the
            target scheme is different, the switch shall take place on the T +
            15th day or the subsequent business day, if T + 15th day is a
            non-business day (T being the last SIP instalment date).
          </div>
        )}
        <>
          <Checkbox
            onChange={() => setIsChecked((p) => !p)}
            checked={isChecked}
          />
          <span style={{ fontWeight: 500 }}>
            I/We have read and understood the contents of the Offer Document(s),
            Load Structure(s) of the respective Scheme(s) and agree to abide by
            the terms, conditions, rules and regulations of the respective
            Scheme(s).
          </span>
        </>
        <p style={{ fontWeight: 500, marginTop: "10px" }}>
          The ARN holder has disclosed to me/us all the commissions in the form
          of trail commission or any other mode, payable to him for the
          different competing Schemes of various Mutual Funds from amongst which
          the Scheme is being recommended to me/us.
        </p>
        <p style={{ fontWeight: 500, marginTop: "10px" }}>
          Disclaimer: The Registrar of the AMC will allot the number of units
          for the total investment amount. The number of Units allotted by the
          Registrar will reflect in your online account statement within 2
          working days.
        </p>
      </CardComponent>
      <div className="d-flex align-items-center container-margin ">
        <button
          className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            history.replace("/new-investor-transaction/bank-details", state)
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          SUBMIT
        </button>
        <CustomizedDialogs
          open={dialog.open}
          refNo={dialog.appno}
          transactName={
            props.type === "Lumpsum + SIP" ? "Lumpsum + SIP" : "SIP"
          }
          closeModal={gotoTransactionTypes}
          Transaction={true}
          transactionStatus={closeModel}
        />
      </div>
      <KycNotDoneDialog
        message={messageAlert}
        open={erroropen}
        continue={proceed}
        close={exitModel}
      />
      <FreedomSchemeDialog
        open={freedomSchemeDialog.open}
        continue={continueFreedomModel}
        close={exitFreedomModel}
      />
    </>
  );
};

export default connect(
  ({ authReducer, transactions, newinvestor }) => {
    const { token, userId, tran_enable_flag } = authReducer;
    const { euinList } = transactions;
    const {
      schemeparams,
      schemeDetails,
      applicantparams,
      fatcaDetails,
      investmentparams,
      nomineDetails,
    } = newinvestor;
    return {
      token,
      userId,
      tran_enable_flag,
      euinList,
      schemeparams,
      schemeDetails,
      applicantparams,
      investmentparams,
      fatcaDetails,
      nomineDetails,
    };
  },
  {
    getNewPurchaseFundList,
    validateSubBroker,
    swpOptions,
    CalcSIPEnddt,
    submitSipDetails,
    storeSchemeDetails,
    storeSchemeParams,
    getOtherSchemes,
    getNav,
    clearingFirstTimeInvestorJourney,
    getCheckPanKotm,
    getCheckPanAotm,
    FreedomSIPSWPschemes,
    isFreedomSIPEligible,
    FreedomSIPTenures,
    getMinimumAmount,
    PurchaseSaveNominee
  }
)(SipDetails);
function validateSipAutoRenewalMandate(formValues) {
  const mode = formValues["Mode of Registration"]?.value;
  const sipAutoRenewal = formValues.sipAutoRenewal;

  if (!["KOTM", "AOTM"].includes(mode) || !sipAutoRenewal) return true;

  const sipStart = new Date(formValues["SIP Period From"]?.value);
  const sipEnd = new Date(formValues["SIP Period To"]?.value);
  const [dd, mm, yyyy] = formValues["UMRN"]?.value?.["MANDATE END DATE"]?.split("/") || [];
  const mandateEnd = new Date(`${yyyy}-${mm}-${dd}`);
  const installments = +formValues["No of Installments"]?.value || 0;
  const frequency = formValues["Frequency"]?.value?.toLowerCase();

  if ([sipStart, sipEnd, mandateEnd].some(d => isNaN(d.getTime())) || !installments || !frequency) {
    alert("Invalid SIP details. Please check dates, frequency, and installments.");
    return false;
  }

  const extendedEnd = new Date(sipEnd);
  const addDuration = {
    monthly: () => extendedEnd.setMonth(extendedEnd.getMonth() + installments),
    quarterly: () => extendedEnd.setMonth(extendedEnd.getMonth() + installments * 3),
  };

  if (!addDuration[frequency]) {
    alert("Unsupported SIP frequency.");
    return false;
  }

  addDuration[frequency]();

  if (mandateEnd < extendedEnd) {
    alert("As you selected SIP Auto Renewal, the SIP end date after renewal exceeds the mandate end date. Please ensure the mandate is valid for at least two SIP cycles.");
    return false;
  }

  return true;
}
